import React from "react";
import Header from "./components/HeaderFooterLite/Header";
import Content from "./components/PrivacyPolicy";
import Footer from "./components/HeaderFooterLite/Footer";

function PrivacyPolicy() {
  return (
    <div className="wrap-ppolicy">
      <Header />
      <Content />
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
